import React, {ComponentType, Component} from 'react';
import {StyledComponent as StyledComponentType} from 'styled-components';
import {Theme} from '../theme/theme';

/**
 * TODO: Using `AnyStyledComponent` is hopefully temporary.
 * There were type issues in the render if I used `StyledComponent` instead.
 */
export const withComponent = <P, T extends Theme>(BaseComponent: ComponentType<P>) => (
    StyledComponent: StyledComponentType<ComponentType<P>, T, any, any>
) => {
    return class WithComponent extends Component<P> {
        public static StyledComponent = StyledComponent;
        public static displayName = `withComponent(${StyledComponent.displayName})`;

        public render() {
            return <StyledComponent as={BaseComponent} {...this.props} />;
        }
    };
};
